import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { apiService } from '../services/api';

export const useNotifications = (unreadOnly?: boolean) => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['notifications', user?.organizationId, unreadOnly],
    queryFn: () => apiService.notifications.getAll(unreadOnly),
    refetchInterval: 60000, // Poll every minute
    enabled: !!user?.organizationId,
  });
};

export const useUnreadNotificationCount = () => {
  const { data } = useNotifications(true);
  return data?.length || 0;
};

export const useMarkNotificationRead = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => apiService.notifications.markAsRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications', user?.organizationId] });
    },
  });
};

export const useMarkAllNotificationsRead = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => apiService.notifications.markAllAsRead(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications', user?.organizationId] });
    },
  });
};
